import { observer } from "mobx-react-lite";
import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import { langStore } from "@noli/business";
import styles from "./index.module.scss";
import { loginStore } from "@/modules/login/store";
import { SettingLangRecords } from "@/pages/Setting/lang";
interface ContentBlockProps {
  label?: string;
  suffix?: string;
  value?: string | number;
  border?: boolean;
  children?: React.ReactNode;
  onSuffixClick?: (value: string, ref: any) => void;
  disabled?: boolean;
  suffixEnd?: string;
  rowEdit?: boolean;
  hideButton?: boolean;
}
const ContentRow: FC<ContentBlockProps> = (props) => {
  const {
    userState: { userInfo },
  } = loginStore;
  const lang = langStore.tgt;
  const valueInputRef = useRef<HTMLInputElement | null>(null);
  const {
    label,
    suffix,
    value,
    children,
    border,
    onSuffixClick,
    disabled,
    suffixEnd,
    rowEdit,
    hideButton,
  } = props;
  const [editState, setEditState] = useState(false);
  useEffect(() => {
    editState ? valueInputRef?.current?.focus() : valueInputRef?.current?.blur();
  }, [editState]);
  const valueNode = useMemo(() => {
    return (
      <input
        disabled={!editState}
        type="text"
        placeholder={`${SettingLangRecords[lang]["Enter"]}${label}`}
        defaultValue={value}
        className={`${styles.valueInput} ${disabled ? styles.disable : ""}`}
        ref={(ref) => {
          valueInputRef.current = ref;
        }}
        onBlur={(e) => {
          setTimeout(() => {
            setEditState(false);
            valueInputRef?.current?.value !== value &&
              onSuffixClick?.(valueInputRef?.current?.value as string, valueInputRef);
          }, 200);
        }}
      />
    );
  }, [editState, value]);
  useEffect(() => {
    if (valueInputRef?.current) {
      valueInputRef.current.value = value as string;
    }
  }, [value]);
  return (
    <div
      className={styles.contentRowWrapper}
      style={{ borderBottomStyle: border ? "solid" : "none" }}
    >
      {label && <span className={styles.label}>{label}</span>}
      {children ? children : valueNode}
      <button
        disabled={disabled}
        style={{
          visibility: suffix ? "visible" : "hidden",
          display: hideButton ? "none" : "",
        }}
        className={styles.suffix}
        onClick={(e) => {
          e.stopPropagation();
          if (!rowEdit) {
            if (!editState) {
              setEditState(true);
            } else {
              setEditState(false);
            }
          } else {
            onSuffixClick?.(valueInputRef?.current?.value as string, valueInputRef);
          }
        }}
      >
        {editState ? suffixEnd : suffix}
      </button>
    </div>
  );
};
export default observer(ContentRow);
